module.exports = __webpack_public_path__ + "static/media/icon_mouth.38b699a9.svg";